import type { AppTheme } from "@shared/types";

import { pb } from "./pb";
import { navigate } from "./router.svelte";

export interface Builder {
  id: string;
  email: string;
  name: string;
  avatar?: string;
  /**
   * Es la cuenta principal (la del `.env`): la única que entra a los ajustes y
   * ve todas las aplicaciones. La marca la pone el arranque; el servidor lo
   * vuelve a comprobar por el correo.
   */
  admin?: boolean;
  /** La paleta con la que ve el panel. Vacía: la de partida. */
  palette?: AppTheme | null;
  collectionId?: string;
}

/** Usuario del panel con la sesión guardada, o `null`. */
const current = () => (pb.authStore.record as unknown as Builder | null) ?? null;

let me = $state<Builder | null>(current());
/** Sin sesión guardada no hay nada que confirmar: se sabe desde el primer momento. */
let ready = $state(!pb.authStore.isValid);

pb.authStore.onChange(() => {
  me = current();
});

if (pb.authStore.isValid) {
  // Confirmamos con el servidor que la sesión guardada sigue viva.
  pb.collection("builders")
    .authRefresh()
    .catch(() => pb.authStore.clear())
    .finally(() => {
      ready = true;
    });
}

export const session = {
  /** Quien está construyendo, o `null` si no hay nadie. */
  get me(): Builder | null {
    return me;
  },
  /** Ya se sabe si hay sesión o no. Antes de esto no se puede echar a nadie. */
  get ready(): boolean {
    return ready;
  },
  async signIn(email: string, password: string): Promise<void> {
    await pb.collection("builders").authWithPassword(email, password);
  },
  signOut(): void {
    pb.authStore.clear();
    navigate("/admin/entrar", { replace: true });
  },
};
